import React from 'react';
import img from '../assets/account-circle.svg';

type Props = {
  className?: string;
};

export const AccountCircle: React.FC<Props> = ({ className }) => {
  return (
    <div className={className ? className : ''} data-node-id="5:4356">
      <img src={img} alt="account" width={80} height={80} />
    </div>
  );
};

export default AccountCircle;
